import { DocumentsList } from "Components/LegalDocuments/DocumentsList";
import { BlDivider } from "Components/Shared/BlDivider";
import { getApiUrl } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES =
  Resources.Pages.Content.LegalDocuments.Documents.Hunter;

export const HunterLegalDocuments = () => {
  const { t } = useResource();

  const apiUrl = getApiUrl();
  const documents = [
    {
      title: t(COMPONENT_RESOURCES.digitalFranchiseContract.title),
      url: t(COMPONENT_RESOURCES.digitalFranchiseContract.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.affiliateTerms.title),
      url: t(COMPONENT_RESOURCES.affiliateTerms.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.commissionTable.title),
      url: t(COMPONENT_RESOURCES.commissionTable.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.valorVigorPointRules.title),
      url: t(COMPONENT_RESOURCES.valorVigorPointRules.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.valorGeneralRules.title),
      url: t(COMPONENT_RESOURCES.valorGeneralRules.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.nftCollectionRules.title),
      url: t(COMPONENT_RESOURCES.nftCollectionRules.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.generalFranchiseTerms.title),
      url: t(COMPONENT_RESOURCES.generalFranchiseTerms.url, { apiUrl }),
    },
    {
      title: t(COMPONENT_RESOURCES.dataProtectionPrinciples.title),
      url: t(COMPONENT_RESOURCES.dataProtectionPrinciples.url, { apiUrl }),
    },
    {
      title: t(
        Resources.Pages.Content.LegalDocuments.Documents.thanksToYou.title,
      ),
      url: t(Resources.Pages.Content.LegalDocuments.Documents.thanksToYou.url, {
        apiUrl,
      }),
    },
    {
      title: t(COMPONENT_RESOURCES.satisfactionGuarantee.title),
      url: t(COMPONENT_RESOURCES.satisfactionGuarantee.url, { apiUrl }),
    },
  ];

  return (
    <>
      <DocumentsList documents={documents} />
      <BlDivider
        text={t(Resources.Pages.Content.LegalDocuments.previousVersions)}
      />
      <DocumentsList
        documents={[
          {
            title: t(COMPONENT_RESOURCES.previousCommissionTable.title),
            url: t(COMPONENT_RESOURCES.previousCommissionTable.url, { apiUrl }),
          },
          {
            title: t(COMPONENT_RESOURCES.previousAffiliateTerms2.title),
            url: t(COMPONENT_RESOURCES.previousAffiliateTerms2.url, { apiUrl }),
          },
          {
            title: t(COMPONENT_RESOURCES.previousGeneralFranchiseTerms.title),
            url: t(COMPONENT_RESOURCES.previousGeneralFranchiseTerms.url, {
              apiUrl,
            }),
          },
          {
            title: t(COMPONENT_RESOURCES.previousNftCollectionRules.title),
            url: t(COMPONENT_RESOURCES.previousNftCollectionRules.url, {
              apiUrl,
            }),
          },
          {
            title: t(
              COMPONENT_RESOURCES.previousDataProtectionPrinciples.title,
            ),
            url: t(COMPONENT_RESOURCES.previousDataProtectionPrinciples.url, {
              apiUrl,
            }),
          },
          {
            title: t(
              COMPONENT_RESOURCES.previousDataProtectionPrinciples2.title,
            ),
            url: t(COMPONENT_RESOURCES.previousDataProtectionPrinciples2.url, {
              apiUrl,
            }),
          },
          {
            title: t(COMPONENT_RESOURCES.previousAffiliateTerms.title),
            url: t(COMPONENT_RESOURCES.previousAffiliateTerms.url, { apiUrl }),
          },
        ]}
      />
    </>
  );
};
